const SEND_ANALYSE_RESPONSE = {
  OperationResult: 'OperationResult',
  TokenError: 'TokenError',
  NotFound: 'NotFound',
  Unauthorized: 'Unauthorized',
};

export default SEND_ANALYSE_RESPONSE;
